import { from, Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import {
  isArdoqError,
  translateApiError,
  type ArdoqError,
  type Result,
} from '@ardoq/common-helpers';
import type { InitiativeUpdateResponse } from '@ardoq/api-types';
import { api, transformationsApi } from '@ardoq/api';
import { action$, extractPayload, ofType } from '@ardoq/rxbeach';
import { t } from '@ardoq/i18n';
import { showToast, ToastType } from '@ardoq/status-ui';
import { trackEventV2 } from 'tracking/tracking';
import { i18nLocale$ } from 'streams/i18nLocale$';
import {
  dispatchDetectedSetupStatus,
  setupStatusFromError,
} from '../setupStatusDetection';
import { updateStageRequested } from './initiativePageForm$/actions';

const toStageError = (error: ArdoqError): void => {
  if (setupStatusFromError(error)) return;
  const locale = i18nLocale$.state;
  showToast(
    translateApiError(
      error,
      locale,
      t(
        locale,
        'transformations:detail.updateStage.error',
        'Failed to update stage'
      )
    ),
    ToastType.ERROR
  );
};

export const updateStage$: Observable<Result<InitiativeUpdateResponse>> =
  action$.pipe(
    ofType(updateStageRequested),
    extractPayload(),
    switchMap(payload =>
      from(transformationsApi.updateInitiative(payload)).pipe(
        tap(response => {
          if (!isArdoqError(response)) {
            trackEventV2({
              event: 'Initiatives0 Updated initiative',
              payload: { field: payload.field },
            });
          }
        })
      )
    ),
    tap(response => {
      dispatchDetectedSetupStatus(response);
      api.logErrorIfNeeded(response);
      if (isArdoqError(response)) toStageError(response);
    })
  );
